import { render, staticRenderFns } from "./shopSigntodologisticsInfo.vue?vue&type=template&id=0991b168&scoped=true"
import script from "./shopSigntodologisticsInfo.vue?vue&type=script&lang=js"
export * from "./shopSigntodologisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./shopSigntodologisticsInfo.vue?vue&type=style&index=0&id=0991b168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991b168",
  null
  
)

export default component.exports